import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Home from '../views/Home.vue';
import { admin } from './admin';

Vue.use(VueRouter);
const ifAuthenticated = (to: any, from: any, next: any) => {
  if (localStorage.adminKB) {
    next();
    return;
  }
  next('/');
};

const ifNotAuthenticated = (to: any, from: any, next: any) => {
  if (!localStorage.adminKB) {
    next();
    return;
  }
  next('/admin');
};

const routes: RouteConfig[] = [
  {
    path: '/',
    component: Home,
    beforeEnter: ifNotAuthenticated,
  },
  {
    path: '/admin',
    component: () => import('../views/admin/admin.vue'),
    children: admin,

    beforeEnter: ifAuthenticated,
  },
  {
    path: '/print/:id',
    component: () => import('../views/admin/massageorder/print.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
